import { useEffect, useState } from "react";
import { ProductInclusion } from "../../../../../graphql/operations";
import InclusionsGrid from "./InclusionsGrid";
import InclusionsModal from "./InclusionsModal";

interface InclusionsProps {
  inclusions: ProductInclusion[];
  isModalOpen?: number;
}

export default function Inclusions({
  inclusions,
  isModalOpen,
}: InclusionsProps) {
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (isModalOpen > 0) {
      setOpenModal(true);
    }
  }, [isModalOpen]);

  if (inclusions.length === 0) return <></>;

  return (
    <div>
      <InclusionsGrid
        inclusions={inclusions}
        onOpenModal={() => setOpenModal(true)}
      />
      <InclusionsModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        inclusions={inclusions}
      />
    </div>
  );
}
